import Kuroshiro from 'kuroshiro';
import KuromojiAnalyzer from 'kuroshiro-analyzer-kuromoji';
import { toKatakana as romaToKana } from 'wanakana';


const getResource = (record) => {
  if (record.isCleanCus) {
    return "customers-clean";
  }
  else if (record.isInspectCus) {
    return "customers-inspect";
  }
  else if (record.isConstructCus) {
    return "customers-construct";
  }
  else if (record.isGarbageCommitCus) {
    return "customers-garbage-commit";
  }
  else if (record.isGarbageAllowCus) {
    return "customers-garbage-allow";
  }
  else if (record.isWasteCus) {
    return "customers-waste";
  }
}

const checkMonthChoices = [
  { id: "1", name: "1月" },
  { id: "2", name: "2月" },
  { id: "3", name: "3月" },
  { id: "4", name: "4月" },
  { id: "5", name: "5月" },
  { id: "6", name: "6月" },
  { id: "7", name: "7月" },
  { id: "8", name: "8月" },
  { id: "9", name: "9月" },
  { id: "10", name: "10月" },
  { id: "11", name: "11月" },
  { id: "12", name: "12月" },
];

const checkWeekChoices = [
  { id: "月", name: "月" },
  { id: "火", name: "火" },
  { id: "水", name: "水" },
  { id: "木", name: "木" },
  { id: "金", name: "金" },
  { id: "土", name: "土" },
  { id: "日", name: "日" },
];

const customerTypeChoices = [
  { id: "isCleanCus", name: "浄化槽清掃" },
  { id: "isInspectCus", name: "浄化槽点検" },
  { id: "isConstructCus", name: "浄化槽修理" },
  { id: "isGarbageCommitCus", name: "ごみ収集委託" },
  { id: "isGarbageAllowCus", name: "ごみ収集許可" },
  { id: "isWasteCus", name: "し尿" },
];

const getCustomerTypeName = (type) => {
  const nameArray = [];
  if (type.isCleanCus) {
    nameArray.push("清掃");
  }
  if (type.isInspectCus) {
    nameArray.push("点検");
  }
  if (type.isConstructCus) {
    nameArray.push("修理");
  }
  if (type.isGarbageCommitCus) {
    nameArray.push("委託");
  }
  if (type.isGarbageAllowCus) {
    nameArray.push("許可");
  }
  if (type.isWasteCus) {
    nameArray.push("し尿");
  }
  return nameArray;
}

const getResourceName = (resource) => {
  if (resource.includes("-clean")) {
    return "浄化槽清掃";
  } else if (resource.includes("-inspect")) {
    return "浄化槽点検";
  } else if (resource.includes("-construct")) {
    return "浄化槽修理";
  } else if (resource.includes("-garbage-commit")) {
    return "ごみ収集委託";
  } else if (resource.includes("-garbage-allow")) {
    return "ごみ収集許可";
  } else if (resource.includes("-waste")) {
    return "し尿";
  }
};

const cleanRangeChoices = [
  { id: 1, name: "全槽" },
  { id: 2, name: "1・2" },
  { id: 3, name: "1のみ" }
]

const cleanTimeChoices = [
  { id: 1, name: "AM①" },
  { id: 2, name: "AM②" },
  { id: 3, name: "PM③" },
  { id: 4, name: "PM④" },
  { id: 5, name: "1日" },
]

const invoiceChoices = [
  { id: 1, name: "清掃" },
  { id: 2, name: "点検" },
  { id: 3, name: "修理" },
  { id: 4, name: "ごみ収集委託" },
  { id: 5, name: "ごみ収集許可" },
  { id: 5, name: "し尿" },
]

const areaChoices = [
  { id: "08", name: "茨城県" },
  { id: "09", name: "栃木県" },
  { id: "10", name: "群馬県" },
  { id: "11", name: "埼玉県" },
  { id: "12", name: "千葉県" },
  { id: "13", name: "東京都" },
  { id: "14", name: "神奈川県" },
  { id: "01", name: "北海道" },
  { id: "02", name: "青森県" },
  { id: "03", name: "岩手県" },
  { id: "04", name: "宮城県" },
  { id: "05", name: "秋田県" },
  { id: "06", name: "山形県" },
  { id: "07", name: "福島県" },
  { id: "15", name: "新潟県" },
  { id: "16", name: "富山県" },
  { id: "17", name: "石川県" },
  { id: "18", name: "福井県" },
  { id: "19", name: "山梨県" },
  { id: "20", name: "長野県" },
  { id: "21", name: "岐阜県" },
  { id: "22", name: "静岡県" },
  { id: "23", name: "愛知県" },
  { id: "24", name: "三重県" },
  { id: "25", name: "滋賀県" },
  { id: "26", name: "京都府" },
  { id: "27", name: "大阪府" },
  { id: "28", name: "兵庫県" },
  { id: "29", name: "奈良県" },
  { id: "30", name: "和歌山県" },
  { id: "31", name: "鳥取県" },
  { id: "32", name: "島根県" },
  { id: "33", name: "岡山県" },
  { id: "34", name: "広島県" },
  { id: "35", name: "山口県" },
  { id: "36", name: "徳島県" },
  { id: "37", name: "香川県" },
  { id: "38", name: "愛媛県" },
  { id: "39", name: "高知県" },
  { id: "40", name: "福岡県" },
  { id: "41", name: "佐賀県" },
  { id: "42", name: "長崎県" },
  { id: "43", name: "熊本県" },
  { id: "44", name: "大分県" },
  { id: "45", name: "宮崎県" },
  { id: "46", name: "鹿児島県" },
  { id: "47", name: "沖縄県" },
];

const formatPhoneNumberStrict = (phoneNumber) => {
  if (/^0[789]0\d{8}$/.test(phoneNumber)) {
    // 携帯番号（090, 080, 070 など）
    return phoneNumber.replace(/^(\d{3})(\d{4})(\d{4})$/, "$1-$2-$3");
  } else if (/^0\d{2}-?\d{1,4}-?\d{4}$/.test(phoneNumber)) {
    // 電話番号２
    return phoneNumber.replace(/^(\d{2,4})(\d{3,4})(\d{4})$/, "$1-$2-$3");
  } else {
    return phoneNumber; // 形式が不明ならそのまま返す
  }
};

const formatPostalCode = (postalCode) => {
  // 数値のみの郵便番号を処理
  const cleanCode = postalCode.toString().replace(/[^\d]/g, ""); // 数字以外を削除

  if (/^\d{7}$/.test(cleanCode)) {
    // 正しく7桁なら 3-4 でフォーマット
    return cleanCode.replace(/^(\d{3})(\d{4})$/, "$1-$2");
  }

  return postalCode; // 7桁でない場合はそのまま返す
};

const isOverdue = (record) => {
  if (!record.invoiceDate || record.isPay) return false; // 領収済みなら赤くしない
  const invoiceDate = new Date(record.invoiceDate);
  const today = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);
  return invoiceDate < oneMonthAgo;
};

const monthChoices = Array.from({ length: 12 }, (_, i) => ({
  id: (i + 1),
  name: `${i + 1}月`
}));

const DownloadFile = async (filePath) => {
  window.open(`${process.env.REACT_APP_API_DIR}/documents/download?filePath=${filePath}`)
};

const formatToJapaneseDate = (date) => {
  return new Intl.DateTimeFormat("ja-JP-u-ca-japanese", {
    era: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(date);
};

const formatDateToYMDSimple = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 月を2桁にする
  const day = String(date.getDate()).padStart(2, "0"); // 日を2桁にする
  return `${year}-${month}-${day}`;
};

const getAllowance = (pumpingAmount, num) => {
  let allowance = 0
  if (num !== 0) {
    allowance = (Math.round((pumpingAmount * 540) / 10) * 10) / num;
  }
  return allowance;
}

const getStaffNum = (record) => {
  let num = 0;
  if (record.staffName && record.staffName !== "") num++;
  if (record.staffName2 && record.staffName2 !== "") num++;

  return num;
}

const getAddressCity = (address) => {
  const cityMatch = address.match(/市(.+)/);
  return cityMatch ? cityMatch[1].trim().replace(/\d.*/, "").trim() : address.replace(/\d.*/, "").trim();
}

const getNameAndCompanyName = (surname, name, companyName) => {
  if (surname || name) {
    return `${surname ?? ""} ${name ?? ""}`
  }
  else {
    return `${companyName ?? ""}`
  }
}

const getNameAndCompanyNamewithAddress = (data) => {
  // if (data.surname || data.name) {
  //   if (data.address) {
  //     return `${data.surname ?? ""} ${data.name ?? ""}(${data.address ?? ""}${data.address2 ?? ""}${data.address3 ?? ""}${data.address4 ?? ""}${data.address5 ?? ""})`
  //   }
  //   else {
  //     return `${data.surname ?? ""} ${data.name ?? ""}`
  //   }

  // }
  // else {
  //   if (data.address) {
  //     return `${data.companyName ?? ""}(${data.address ?? ""}${data.address2 ?? ""}${data.address3 ?? ""}${data.address4 ?? ""}${data.address5 ?? ""})`
  //   }
  //   else {
  //     return `${data.companyName ?? ""}`
  //   }
  // }
  return `${data?.bukken ?? ""}(${data?.address ?? ""}${data?.address2 ?? ""}${data?.address3 ?? ""}${data?.address4 ?? ""}${data?.address5 ?? ""})`
}

const extractPrefecture = (address) => {
  if (!address) return "";
  return areaChoices.find(pref => address.startsWith(pref.name)) || "";
};

const extractCity = (address, cityList) => {
  if (!address) return "";
  return cityList.find(city => address.includes(city.name)) || "";
};

const extractTown = (address, townList) => {
  if (!address) return "";
  return townList.find(town => address.includes(town.name)) || "";
};

const handleCityListLoad = async (pref) => {
  const res1 = await fetch('https://geolonia.github.io/japanese-addresses/api/ja.json');
  const allData = await res1.json();
  let cities = allData[pref];

  let cityList = [];

  if (cities && cities.length > 0) {
    const priority = 'ひたちなか市';
    if (cities.includes(priority)) {
      cities = [
        priority,
        ...cities.filter(c => c !== priority)
      ];
    }

    cityList = cities.map((name, index) => ({
      id: index + 1,
      name,
    }));
  }

  return cityList
};

const handleTownListLoad = async (pref, city) => {
  const url =
    'https://geolonia.github.io/japanese-addresses/api/ja/' +
    `${encodeURIComponent(pref)}/` +
    `${encodeURIComponent(city)}.json`;

  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }
  const towns = await res.json();

  // 「大字」を削除しつつ、末尾の「数字＋丁目」を削る正規表現
  const regexChome = /[0-9一二三四五六七八九十百千万]+丁目$/;

  // 1) 「大字」を除去 → 2) 「X丁目」を削除 → 3) 空文字除去
  const cleaned = towns
    .map(item => {
      let name = item.town.replace(/^大字/, '');
      name = name.replace(regexChome, '');
      return name.trim();
    })
    .filter(name => name !== "ナメシ");

  // 4) 重複を排除
  const unique = Array.from(new Set(cleaned));

  // 5) { id, name } 形式に整形
  const townList = unique.map(name => ({ id: name, name }));

  return townList;
};

const handlePostCodeChange = async (value) => {
  const rawPostCode = value;
  if (!rawPostCode) return null;
  const postCode = rawPostCode.replace(/[^0-9]/g, "");
  if (!postCode) return null;
  if (postCode.length !== 7) return null;
  try {
    const response = await fetch(
      `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${postCode}`
    );
    const data = await response.json();
    if (data.results && data.results.length > 0) {
      const { address1, address2, address3, address4 } = data.results[0];
      console.log(address1);
      console.log(address2);
      console.log(address3);
      console.log(address4)
      return { address1, address2, address3 }
    }

  } catch (error) {
    console.error(`住所の取得に失敗しました:${error}`);
    throw error;
  }
};

const handleAddressChange = async (address) => {
  if (!address) return;
  try {
    const response = await fetch(
      `https://zipcoda.net/api?address=${encodeURIComponent(address)}`
    );
    const data = await response.json();
    if (data.items && data.items.length > 0) {
      const postcode = data.items[0].zipcode;
      return formatPostalCode(postcode);
    }

  } catch (error) {
    console.error("郵便番号の取得に失敗しました:", error);
    throw error;
  }
};

async function initKuroshiro() {
  try {
    const kuroshiro = new Kuroshiro();
    await kuroshiro.init(
      new KuromojiAnalyzer({
        dictPath: `/dict/`
      })
    );
    return kuroshiro;
  } catch (e) {
    console.error(e);
    throw e;
  }
}

function getRomaToKana(raw) {
  return romaToKana(raw);
}

const validateKatakana = (value) => {
  if (value) {
    const katakanaRegex = /^[\u30A1-\u30FA\u30FC0-9０-９\s　]+$/;
    return katakanaRegex.test(value) ? undefined : '全角カタカナ、数字、空白で入力してください';
  }
};

// staff API functions
export const fetchStaffList = async () => {
  const res = await fetch(`${process.env.REACT_APP_API_DIR}/staff`, {
    method: "GET",
    headers: new Headers({ "Content-Type": "application/json" }),
    mode: "cors",
    credentials: "include",
  });
  const { data } = await res.json();
  return data.map(staff => ({ id: staff.name, name: staff.name, dbId: staff.id }));
};

export const addStaff = async (name) => {
  await fetch(`${process.env.REACT_APP_API_DIR}/staff`, {
    method: "POST",
    headers: new Headers({ "Content-Type": "application/json" }),
    mode: "cors",
    credentials: "include",
    body: JSON.stringify({ name })
  });
};

export const deleteStaff = async (dbId) => {
  await fetch(`${process.env.REACT_APP_API_DIR}/staff/${dbId}`, {
    method: "DELETE",
    headers: new Headers({ "Content-Type": "application/json" }),
    mode: "cors",
    credentials: "include",
  });
};


export { getResource, checkMonthChoices, checkWeekChoices, customerTypeChoices, cleanRangeChoices, cleanTimeChoices, getResourceName, formatPhoneNumberStrict, formatPostalCode, isOverdue, monthChoices, DownloadFile, formatToJapaneseDate, formatDateToYMDSimple, getCustomerTypeName, getAllowance, getStaffNum, getAddressCity, getNameAndCompanyName, getNameAndCompanyNamewithAddress, invoiceChoices, areaChoices, extractPrefecture, extractCity, extractTown, handleCityListLoad, handleTownListLoad, handlePostCodeChange, handleAddressChange, initKuroshiro, getRomaToKana, validateKatakana }